import { useSyncExternalStore } from 'react';
import { subscribeMenuOverlay, getMenuOverlayOpen } from '@/lib/menuOverlayStore';

/**
 * 画面に実際に描画される「幕」。
 *
 * アプリ全体で1枚だけ（App.tsx）に置き、開いているパネルが1つ以上あれば背後のページを暗くする。
 * z-20 に置くことで、ヘッダー（z-30 / z-40）や開いているパネル（z-40 / z-50）の下に潜り込み、
 * それらの操作を邪魔しない。幕を常に1枚だけ使い回すので、メニューからメニューへ切り替えても
 * 暗さが途切れず、チラつかない。
 */
export default function MenuOverlayHost() {
  const open = useSyncExternalStore(subscribeMenuOverlay, getMenuOverlayOpen, () => false);

  return (
    <div
      aria-hidden="true"
      className={`fixed inset-0 z-20 bg-black/40 transition-opacity duration-300 ease-out ${
        open ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
    />
  );
}